"use strict";

;
(function (CollectionProducts, $) {
  CollectionProducts.init = function () {
    $('.grid-product__swatch').tooltip({
      position: {
        my: 'center',
        at: 'center top+50',
        using: function using(position, feedback) {
          $(this).css(position);
          $('<div>').addClass('arrow').addClass(feedback.vertical).addClass(feedback.horizontal).appendTo(this);
        }
      }
    });
    $('.grid-product__swatch').each(function () {
      $(this).tooltip('option', 'classes.ui-tooltip', $(this).attr('data-tooltip'));
    });
  };
})(window.CollectionProducts = window.CollectionProducts || {}, jQuery, undefined);